import {useEffect, useState} from 'react';

import {HorizontalDivider} from '../../commonComponents/HorizontalDivider';
import JsonData from '../../data/data.json';

import {BestSeller} from './BestSeller';
import {Carousel} from './Carousel';
import {GoldCollection} from './GoldCollection';
import {ImitationCollection} from './ImitationCollection';
import {SilverCollection} from './SilverCollection';
import {TestimonialSection} from './TestimonialSection';

const HomeScreen = () => {
  const [websiteData, setWebsiteData] = useState({});

  useEffect (() =>{
    setWebsiteData(JsonData);
  }, []);

  return(
    <div className={'bg-[#FAF9F6]'}>
      <Carousel data={JsonData.CarouselSection} />
      <HorizontalDivider />
      <BestSeller data={JsonData.BestSellerSection} />
      <HorizontalDivider />
      <SilverCollection data={JsonData.SilverCollection} />
      <HorizontalDivider />
      <ImitationCollection data={JsonData.ImitationCollection}  />
      <HorizontalDivider />
      <GoldCollection data={JsonData.GoldCollection} />
      <TestimonialSection data={JsonData.Testimonials} />
    </div>
  );
};

export default HomeScreen;
